import type React from 'react';

import { usePhoneConfirmation } from '@/hooks/registration/usePhoneConfirmation';

import PhoneConfirmationView from './PhoneConfirmation.view';

export function PhoneConfirmation(): React.JSX.Element {
  const { state, handlers } = usePhoneConfirmation();

  return (
    <PhoneConfirmationView
      codeLength={state.codeLength}
      maskedPhone={state.maskedPhone}
      code={state.code}
      codeError={state.codeError}
      globalError={state.globalError}
      isSubmitting={state.isSubmitting}
      isSubmitDisabled={state.isSubmitDisabled}
      resendDisabled={state.resendDisabled}
      onCodeChange={handlers.handleCodeChange}
      onSubmit={handlers.handleSubmit}
      onResend={handlers.handleResend}
    />
  );
}

PhoneConfirmation.displayName = 'PhoneConfirmation';

export default PhoneConfirmation;
